import React, { FC, useEffect, useImperativeHandle, useMemo, useState } from 'react';
import H5AudioPlayer, { default as ReacttH5AudioPlayer, RHAP_UI } from 'react-h5-audio-player';
import classNames from 'classnames';
import Loading from 'components/layout/Loading';
import { useStore } from 'store/zustandProvider';
import ServiceBriefs from 'services/ServiceBriefs';
interface AudioPlayerProps {
  audio: string;
  simple?: boolean;
  autoPlay?: boolean;
  onClick?: () => any;
  customPlay?: React.ReactNode;
  className?: string;
  briefUUID?: string
}
const AudioPlayer = React.forwardRef<HTMLDivElement, AudioPlayerProps>(
  ({ audio, autoPlay = false, simple = false, onClick, customPlay, className = '', briefUUID = "" }, ref) => {
    const [playerState, setPlayerState] = useState<'paused' | 'playing' | 'end'>('paused');

    const { setCurrentAudio, currentAudio, playlist } = useStore();

    const [loading, setLoading] = useState(true);
    useImperativeHandle<{}, { play: any }>(ref, () => ({
      play: (_audio) => {
        //debugger;
        // if (_audio) {
        //   audioPlayerRef.current.audio.current.src = _audio;
        // }
        audioPlayerRef.current.audio.current.play();

        setPlayerState('playing');
      },
      pause: () => {
        audioPlayerRef.current.audio.current.pause();
        setPlayerState('paused');
      }
    }));

    useEffect(() => {
      setTimeout(() => setLoading(false));
    });

    useEffect(() => {
      return () => {
        //console.log('Clean up', audio);
        try {
          //if (playerState === 'playing') {
          audioPlayerRef.current.audio.current.pause();
          setPlayerState('paused');
          //}
        } catch (e) {
          //console.warn(e);
        }
      };
    }, []);

    const audioPlayerRef = React.useRef<H5AudioPlayer>();
    const onPlay = async () => {
      if (currentAudio?.audio?.current?.src !== audio) {
        try {
          currentAudio.audio.current.pause();
        } catch (e) {
          //console.warn(e);
        }
      }
      setCurrentAudio(audioPlayerRef.current);
      setPlayerState('playing');
      onClick && (await onClick());

      if (briefUUID) {
        ServiceBriefs.listened(briefUUID).catch(e => {


        })
      }
    };

    const onPause = () => {
      setPlayerState('paused');
    };


    const onEnded = () => {

      console.log("🚀 ~ onEnded ~ onEnded", audio)
      debugger
      const audioIndex = playlist.findIndex(src => src === audio);
      if (audioIndex < playlist.length - 1) {
        //Try next play
        try {
          //@ts-ignore
          document.querySelectorAll(".rhap_main-controls button")[audioIndex + 1].click()
        } catch (e) { }
      }
    }
    const classes = useMemo(() => classNames('audioPlayer ', className, playerState, { simple }), [
      playerState,
      audio,
      autoPlay,
      className
    ]);

    if (loading) return <Loading />;

    if (simple) {
      return (
        <ReacttH5AudioPlayer
          ref={audioPlayerRef}
          className={classes}
          src={audio}
          autoPlayAfterSrcChange={autoPlay}
          autoPlay={autoPlay}
          showJumpControls={false}
          showFilledVolume={false}
          customProgressBarSection={[RHAP_UI.MAIN_CONTROLS]}
          customVolumeControls={[]}
          onPlay={onPlay}
          onPause={onPause}
          customControlsSection={[]}
          customIcons={{}}
          onEnded={onEnded}
        />
      );
    } else {
      return (
        <ReacttH5AudioPlayer
          className={classes}
          //@ts-ignore
          ref={audioPlayerRef}
          autoPlay={autoPlay}
          autoPlayAfterSrcChange={autoPlay}
          //layout="horizontal"
          src={audio}
          showJumpControls={false}
          customProgressBarSection={[
            RHAP_UI.MAIN_CONTROLS,
            RHAP_UI.PROGRESS_BAR,
            // <div className="ListenNow">Listen Now</div>,
            RHAP_UI.DURATION
            //  RHAP_UI.CURRENT_TIME,
          ]}
          customVolumeControls={[]}
          onPlay={onPlay}
          onPause={onPause}
          customControlsSection={
            [
              //RHAP_UI.CURRENT_TIME,
              //RHAP_UI.DURATION
            ]
          }
          customIcons={{
            play: playerState !== 'playing' && customPlay
            //pause: <PauseCircleOutlined className="bf-icon pause-icon" />
          }}
          onEnded={onEnded}
        // other props here
        />
      );
    }
  }
);
export default AudioPlayer;
